import React, { PropTypes } from "react";
import styled from "styled-components";
import { NitroText } from "nitro-components";

const LegendContainer = styled.div`
display:flex;
flex-direction: row;
justify-content: center;
align-items: center;
width:100%;
margin-top:25px;
padding-bottom:5px;
margin-left:30px;
`;

const LegendSection = styled.div`
display:flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
width:30%;
`;

const LegendContent = styled.div`
display:flex;
flex-direction: row;
justify-content: space-between;
align-items: center;
`;

const LegendColor = styled.div`
width:17px;
height:15px;
background-color: ${props => props.theme.color[props.variant]};
margin-right:10px;
`;

const ChartLegend = props => (
	<LegendContainer>
		<LegendSection>
			{props.data.map(function(legend, index) {
				return (
					<LegendContent key={index}>
						<LegendColor variant={legend.variant} />
						<NitroText size={13} bold variant="black">
							{legend.value}
						</NitroText>
					</LegendContent>
				);
			})}
		</LegendSection>
	</LegendContainer>
);

ChartLegend.propTypes = {
	data: PropTypes.array
};

ChartLegend.defaultProps = {
	// defaultProp: ''
};

export default ChartLegend;



// WEBPACK FOOTER //
// ./src/components/charts/custom-styles/ChartLegend.js